import React from "react";

function About() {
  return (
    <div className="container mt-3 about" id="hakkimda">
      <div className="row justify-content-center text-center">
        <div className="col-lg-8">
          <h1>HAKKIMDA</h1>
          <p>
            Merhaba ben Berkant,bir Frontend geliştiricisiyim.4 Yıldır aktif
            olarak bu alanda projeler geliştirmekteyim ve yazılım dünyasına
            büyük bir tutkuyla bağlıyım.Kariyerim boyunca, birçok farklı projede
            yer aldım ve birçok müşterinin web arayüz'lerini geliştirmelerine
            yardımcı oldum.Ayrıca, sürekli olarak kendimi geliştirmek için yeni
            teknolojileri araştırmak ve öğrenmek için çaba sarf ediyorum.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
